import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faPowerOff } from "@fortawesome/free-solid-svg-icons";

function SubAdminHeader() {
  const navigate = useNavigate();
  const [subAdmin, setSubAdmin] = useState(null);

  useEffect(() => {
    const storedSubAdmin = sessionStorage.getItem("subAdmin");

    if (storedSubAdmin) {
      setSubAdmin(JSON.parse(storedSubAdmin));
    } else {
      navigate("/SubAdminLogin"); // Redirect to login if no session data
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem("subAdmin");
    navigate("/SubAdminLogin");
  };

  return (
    <div className="header" style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}>
      <Navbar expand="lg">
        <Container fluid>
          <Navbar.Brand href="#">
            <h3 style={{ color: "rgb(6 160 150)", fontWeight: "600", fontSize: "29px" }}>
              Welcome {subAdmin ? subAdmin.name : "Sub Admin"}
            </h3>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="ms-auto my-2 my-lg-0" navbarScroll>
              {subAdmin && (
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faUser} style={{ fontSize: "20px", marginRight: "10px" }} />
                  <span style={{ fontSize: "17px", fontWeight: "600", color: "rgb(6 160 150)" }}>
                    {subAdmin.email}
                    <div className="d-block" style={{ fontSize: "14px", fontWeight: "600" }}>
                      ID: {subAdmin.subAdminId}
                    </div>
                  </span>
                </div>
              )}
              <div className="ms-3" onClick={handleLogout} style={{ cursor: "pointer" }}>
                <FontAwesomeIcon icon={faPowerOff} style={{ fontSize: "25px", marginLeft: "20px", color: "red" }} />
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default SubAdminHeader;
